import { useCallback, useMemo } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { GET_SETTINGS, UPDATE_SETTINGS } from '../graphql/operations';
import useApi from './useApi';

// Hook for getting settings
export function useSettings() {
  const { data, loading, error, refetch } = useQuery(GET_SETTINGS);

  return {
    settings: data?.getSettings || null,
    loading,
    error,
    refetch,
  };
}

// Hook for updating settings
export function useUpdateSettings() {
  const [updateSettings, { loading, error }] = useMutation(UPDATE_SETTINGS, {
    refetchQueries: [{ query: GET_SETTINGS }],
  });

  const execute = async (input) => {
    const { data } = await updateSettings({
      variables: { input },
    });
    return data.updateSettings;
  };

  return { execute, loading, error };
}

// Legacy default export with REST API fallback for backward compatibility
export default function useSettingsRest() {
  const api = useApi();

  const getSettings = useCallback((forceRefresh = false) => api.get('/settings', forceRefresh), [api]);
  const updateSettings = useCallback((payload) => api.put('/settings', payload), [api]);

  return useMemo(
    () => ({
      getSettings,
      updateSettings,
    }),
    [getSettings, updateSettings],
  );
}
